import { render, staticRenderFns } from "./Vinilicas.vue?vue&type=template&id=62c9f6de&scoped=true&"
import script from "./Vinilicas.vue?vue&type=script&lang=js&"
export * from "./Vinilicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9f6de",
  null
  
)

export default component.exports